export default {
    reverseGeocode: 'reverseGeocode',
    crossStreetLookup: 'reverseGeocode/crossStreet'
};



// WEBPACK FOOTER //
// ./services/services/reverseGeocode/types.js